var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blob-content-viewer',{attrs:{"path":_vm.path,"project-path":_vm.projectPath,"ref-type":_vm.refType}})
}
var staticRenderFns = []

export { render, staticRenderFns }